var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "mt-5" },
    [
      _vm.error
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "justify-space-around": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", lg4: "" } },
                [
                  _c("app-alert", {
                    attrs: { text: _vm.error.message },
                    on: { dismissed: _vm.onDismissed }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "justify-space-around": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", lg4: "" } },
            [
              _c(
                "v-alert",
                {
                  attrs: { dismissible: "", type: "success" },
                  model: {
                    value: _vm.successAlert,
                    callback: function($$v) {
                      _vm.successAlert = $$v
                    },
                    expression: "successAlert"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("receiveEmail")))]
              ),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  attrs: { dismissible: "", type: "error" },
                  model: {
                    value: _vm.errorAlert,
                    callback: function($$v) {
                      _vm.errorAlert = $$v
                    },
                    expression: "errorAlert"
                  }
                },
                [_vm._v(_vm._s(_vm.errorMessage))]
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.isValid,
                            callback: function($$v) {
                              _vm.isValid = $$v
                            },
                            expression: "isValid"
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            [
                              _c("v-text-field", {
                                staticClass: "required_field",
                                attrs: {
                                  "prepend-icon": "mail",
                                  label: _vm.$t("loginEmail"),
                                  name: "email",
                                  id: "email",
                                  type: "email",
                                  rules: [
                                    _vm.fieldIsEmail(),
                                    _vm.fieldIsRequired("email")
                                  ]
                                },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onFormSubmitted.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.email,
                                  callback: function($$v) {
                                    _vm.email = $$v
                                  },
                                  expression: "email"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            {
                              attrs: { "align-center": "", "justify-end": "" }
                            },
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showResetPasswordEmailDialog.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("forgetPassword")) + "?")]
                              ),
                              _vm._v(" "),
                              _vm.isNonVPN
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(tooltip) {
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g({}, tooltip.on),
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          color: "primary",
                                                          flat: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            _vm.isShowParseUrlPopup = true
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("fast_forward")
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2133331678
                                      )
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("parseUrl")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("LoaderButton", {
                                attrs: {
                                  buttonText: _vm.$t("send"),
                                  promiseAwait: _vm.onFormSubmitted,
                                  disabled: !_vm.isValid || _vm.btnLoading,
                                  loading: _vm.btnLoading
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ResetPasswordEmailPopup", {
        model: {
          value: _vm.resetPasswordEmailDialog,
          callback: function($$v) {
            _vm.resetPasswordEmailDialog = $$v
          },
          expression: "resetPasswordEmailDialog"
        }
      }),
      _vm._v(" "),
      _c("ParseSignupUrlPopup", {
        attrs: { email: _vm.email },
        model: {
          value: _vm.isShowParseUrlPopup,
          callback: function($$v) {
            _vm.isShowParseUrlPopup = $$v
          },
          expression: "isShowParseUrlPopup"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64e46970", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e46970","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup.vue
// module id = null
// module chunks = 